import { selectors, constants } from '@yola/subscription-manager-js';
import store from 'src/js/store';

const { B2C_HOSTING_GOLD } = constants.SubscriptionType;

const PURCHASED_SUBSCRIPTION = B2C_HOSTING_GOLD;
const PROMO_CAMPAIGN_ID = 'difm-promo';

const getPackage = () => {
  const state = store.getState();

  return selectors.getCurrentPackage(state);
};

const hasGoldSubscription = () => {
  const { type } = getPackage();

  return type === PURCHASED_SUBSCRIPTION;
};

const hasGoldSubscriptionWithDifmPromo = () => {
  const { type, properties } = getPackage();

  return type === PURCHASED_SUBSCRIPTION && properties.promoCampaignId === PROMO_CAMPAIGN_ID;
};

const hasGoldSubscriptionWithoutDifmPromo = () => {
  const { type, properties } = getPackage();

  return type === PURCHASED_SUBSCRIPTION && properties.promoCampaignId !== PROMO_CAMPAIGN_ID;
};

export {
  hasGoldSubscription,
  hasGoldSubscriptionWithDifmPromo,
  hasGoldSubscriptionWithoutDifmPromo,
};
